<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Lançamento</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtlancamento) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo Vistoria</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia_pla06 }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Vistoria</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtvistoria) }}</div>
                </div>
                <div class="form-item">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.xstatus }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label-start">{{ objEdicao.nmestabelecimento }}</div>
                </div>
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
    </div>


    <div v-for="item in lsItens" :key="item.id" class="form-edit-page row-space">
        <div class="tela-dividida row-space">
            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">PAC</label>
                    <div class="field-label field-label-center field-label--destaque">{{ item.nmpac }}</div>
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Prazo</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.dtprazo) }}</div>
                </div>                
            </div>

            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">Data Prevista</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.acdtprevista) }}</div>
                </div>

                <ToggleButton
                    v-model="item.aprovado"
                    label-true="APROVAR"
                    label-false="REPROVAR"
                    label-caption="Análise"
                    btnWidth="90px"
                />
                
                <button v-if="item.conferir && perfilCorreto" class="btn-confirm" @click="confirmarItem(item)">PROTOCOLAR ANÁLISE</button>
            </div>
        </div>
        

        <div class="tela-dividida">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Não Conformidade</label>
                    <textarea v-model="item.pacobs" rows="5" maxlength="3000" readonly/>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ação Corretiva</label>
                    <textarea v-model="item.acdetalhamento" rows="5" maxlength="3000" readonly/>
                </div>
            </div>
        </div>
        

        <div class="row-space"></div>
        <div v-if="item.aprovado === false">
            <div class="form-item">
                <label class="label-caption">Justificativa</label>
                <textarea v-model="item.obsaprovacao" rows="3" maxlength="3000" />
            </div>
        </div>
    </div>


    <div v-if="perfilCorreto" class="row-end">
        <button class="btn-cancel" @click="salvarAnalise">HOMOLOGAR ANÁLISE</button>
    </div>

    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />
        

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarAssinatura } from '@/models/assinatura';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';
import ToggleButton from '@/components/ToggleButton.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref('Relatório encerrado e homologado com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref({});
const perfilCorreto = ref(false);
const showOkModal = ref(false);

const closeForm = () => {
    emit('save');
    emit('close'); 
};

async function salvarAnalise(){
    try{
        if (lsItens.value.filter(a => a.aprovado === null).length > 0) throw new Error('Necessário "CONFIRMAR" todos os ítens');
        if (lsItens.value.filter(a => a.aprovado === false && !a.obsaprovacao).length > 0) throw new Error('Necessário justificar ítens não aprovados');
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        // SALVAR ANÁLISES DOS ITENS INDIVIDUAIS
        for (const item of lsItens.value){
            const rItem = await Api.genericPut('/cad/pla08_item', {
                id: item.id,
                obsaprovacao: item.obsaprovacao,
                iduaprovacao: globalStore.idusuario,
                ssaprovacao: globalStore.idlogin,
                staprovacao: (item.aprovado) ? 1 : 0,
                idusuario: globalStore.idusuario});

            if (rItem.bolok !== 1) {
                throw new Error(rItem.erro || 'Falha ao gravar análise de ítem');
            }
        }
        
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLA08|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.xsequencia}|HOMOLOGAÇÃO-INSPETOR`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLA08';
        objAssinatura.value.acao = 'pla08_encerramento_aprovacao';

        const respAss = await Api.genericPut('/pla/assinar', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        
        if (!objEdicao.value.id){
            // SELECIONA OBJETO PRINCIPAL
            const rPla08 = await Api.genericPost('/lspla/pla08', {idep: globalStore.idep, id: props.idEdicao});
            objEdicao.value = rPla08[0];
            perfilCorreto.value = (objEdicao.value.status === 4 && globalStore.ckperfilinspetor);
            if (!perfilCorreto.value) {msgAlerta.value = `ATENÇÃO: ${objEdicao.value.xstatus}`}
        }

        const rItens = await Api.genericPost('/lspla/pla08_itens', {id: props.idEdicao});
        lsItens.value = rItens.map(item => ({
            ...item,
            aprovado: null
        }));

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
};

async function confirmarItem(obj) {
    try {
        obj.conferir = false;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}


onMounted(lerDados);
</script>

<style scoped>
.tela-dividida {
    display: flex;
    gap: 10px;
    box-sizing: border-box;
}

.coluna {
    flex: 1;
    display: flex;
    gap: 10px;
    align-items: end;
}

.esquerda {
    background-color: #3498db;
}

.direita {
    background-color: #2ecc71;
}
</style>
